'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useRef } from 'react';
import { KOREA_MAP_VIEWBOX, KOREA_SIDO_SHAPES } from './koreaSidoPaths';
interface RegionMapProps {
  selectedSidoCode?: string | null;
  onSelectSido: (code: string) => void;
  enabledSidoCodes: Set<string>;
}
const LABEL_FONT_SIZE = 17;
const CHIP_HEIGHT = 28; // 보이는 칩 높이(viewBox 단위)
const HIT_HEIGHT = 64; // 투명 탭 영역 높이 — 손가락 큰 사용자도 누를 수 있게 넉넉히
const HIT_PADDING_X = 14;
const chipWidth = (labelText: string) => labelText.length * LABEL_FONT_SIZE + 16;
export const RegionMap = t0 => {
  const $ = _c(14);
  const {
    selectedSidoCode,
    onSelectSido,
    enabledSidoCodes
  } = t0;
  const groupRefs = useRef(new Map());
  let t1;
  if ($[0] !== enabledSidoCodes) {
    t1 = t2 => {
      const {
        code
      } = t2;
      return enabledSidoCodes.has(code);
    };
    $[0] = enabledSidoCodes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const enabledShapes = KOREA_SIDO_SHAPES.filter(t1);
  let t2;
  if ($[2] !== selectedSidoCode) {
    t2 = t3 => {
      const {
        code: code_0
      } = t3;
      return code_0 === selectedSidoCode;
    };
    $[2] = selectedSidoCode;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const hasEnabledSelection = enabledShapes.some(t2);
  const rovingCode = hasEnabledSelection ? selectedSidoCode : enabledShapes[0]?.code;
  const selectAndFocus = code_1 => {
    onSelectSido(code_1);
    groupRefs.current.get(code_1)?.focus();
  };
  const moveSelection = (fromCode, step) => {
    const currentIndex = enabledShapes.findIndex(t3 => {
      const {
        code: code_2
      } = t3;
      return code_2 === fromCode;
    });
    if (currentIndex === -1) {
      return;
    }
    const nextShape = enabledShapes[(currentIndex + step + enabledShapes.length) % enabledShapes.length];
    selectAndFocus(nextShape.code);
  };
  const handleKeyDown = (event, code_3) => {
    bb28: switch (event.key) {
      case "Enter":
      case " ":
        {
          event.preventDefault();
          onSelectSido(code_3);
          break bb28;
        }
      case "ArrowDown":
      case "ArrowRight":
        {
          event.preventDefault();
          moveSelection(code_3, 1);
          break bb28;
        }
      case "ArrowUp":
      case "ArrowLeft":
        {
          event.preventDefault();
          moveSelection(code_3, -1);
          break bb28;
        }
      case "Home":
        {
          event.preventDefault();
          if (enabledShapes[0]) {
            selectAndFocus(enabledShapes[0].code);
          }
          break bb28;
        }
      case "End":
        {
          event.preventDefault();
          const lastShape = enabledShapes.at(-1);
          if (lastShape) {
            selectAndFocus(lastShape.code);
          }
        }
    }
  };
  let t4;
  if ($[4] !== enabledSidoCodes || $[5] !== selectedSidoCode) {
    t4 = code_4 => {
      const isEnabled = enabledSidoCodes.has(code_4);
      const isSelected = selectedSidoCode === code_4;
      if (!isEnabled) {
        return "fill-Gray-400";
      }
      return isSelected ? "fill-Gray-white" : "fill-Gray-700";
    };
    $[4] = enabledSidoCodes;
    $[5] = selectedSidoCode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const labelClassName = t4;
  const t5 = "mx-auto block h-auto max-h-[56vh] w-full max-w-[420px]";
  const t6 = KOREA_MAP_VIEWBOX;
  const t7 = "radiogroup";
  const t8 = "\uC2DC\xB7\uB3C4 \uC120\uD0DD";
  const t9 = KOREA_SIDO_SHAPES.map(sido => {
    const isEnabled_0 = enabledSidoCodes.has(sido.code);
    const isSelected_0 = selectedSidoCode === sido.code;
    return <g key={sido.code} ref={element => {
      if (element) {
        groupRefs.current.set(sido.code, element);
      } else {
        groupRefs.current.delete(sido.code);
      }
    }} role="radio" aria-checked={isSelected_0} aria-label={sido.labelText} aria-disabled={!isEnabled_0} tabIndex={isEnabled_0 && sido.code === rovingCode ? 0 : -1} className={cn("group outline-none", isEnabled_0 ? "cursor-pointer" : "cursor-default")} onClick={() => {
      if (isEnabled_0) {
        onSelectSido(sido.code);
      }
    }} onKeyDown={event_0 => {
      if (isEnabled_0) {
        handleKeyDown(event_0, sido.code);
      }
    }}><path d={sido.d} fillRule="evenodd" strokeWidth={1} strokeLinejoin="round" className={cn("stroke-Gray-300 transition-colors duration-200", !isEnabled_0 && "fill-Gray-50", isEnabled_0 && !isSelected_0 && "fill-Gray-100 group-hover:fill-B-50", isSelected_0 && "fill-B-500")} /><path d={sido.d} fill="none" strokeWidth={2} strokeLinejoin="round" vectorEffect="non-scaling-stroke" className="pointer-events-none stroke-transparent group-focus-visible:stroke-B-500" /></g>;
  });
  let t10;
  if ($[7] !== selectedSidoCode) {
    t10 = KOREA_SIDO_SHAPES.filter(_temp).map(sido_0 => {
      const isSelected_1 = selectedSidoCode === sido_0.code;
      return <g key={`leader-${sido_0.code}`} className="pointer-events-none"><line x1={sido_0.anchorX} y1={sido_0.anchorY} x2={sido_0.labelX} y2={sido_0.labelY} strokeWidth={1} className={isSelected_1 ? "stroke-B-500" : "stroke-Gray-300"} /><circle cx={sido_0.anchorX} cy={sido_0.anchorY} r={2} className={isSelected_1 ? "fill-B-500" : "fill-Gray-300"} /></g>;
    });
    $[7] = selectedSidoCode;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = KOREA_SIDO_SHAPES.map(sido_1 => {
    const isEnabled_1 = enabledSidoCodes.has(sido_1.code);
    const isSelected_2 = selectedSidoCode === sido_1.code;
    if (!sido_1.isExternal) {
      return <text key={`label-${sido_1.code}`} x={sido_1.labelX} y={sido_1.labelY} fontSize={LABEL_FONT_SIZE} textAnchor="middle" dominantBaseline="central" aria-hidden={true} className={cn("pointer-events-none select-none font-600", labelClassName(sido_1.code))}>{sido_1.labelText}</text>;
    }
    const width = chipWidth(sido_1.labelText);
    return <g key={`label-${sido_1.code}`} aria-hidden={true} className={isEnabled_1 ? "cursor-pointer" : "cursor-default"} onClick={() => {
      if (isEnabled_1) {
        selectAndFocus(sido_1.code);
      }
    }}><rect x={sido_1.labelX - width / 2 - HIT_PADDING_X} y={sido_1.labelY - HIT_HEIGHT / 2} width={width + HIT_PADDING_X * 2} height={HIT_HEIGHT} fill="transparent" pointerEvents="all" /><rect x={sido_1.labelX - width / 2} y={sido_1.labelY - CHIP_HEIGHT / 2} width={width} height={CHIP_HEIGHT} rx={CHIP_HEIGHT / 2} strokeWidth={1} className={cn("pointer-events-none transition-colors", !isEnabled_1 && "fill-Gray-50 stroke-Gray-300", isEnabled_1 && !isSelected_2 && "fill-Gray-white stroke-Gray-300", isSelected_2 && "fill-B-500 stroke-B-500")} /><text x={sido_1.labelX} y={sido_1.labelY} fontSize={LABEL_FONT_SIZE} textAnchor="middle" dominantBaseline="central" className={cn("pointer-events-none select-none font-600", labelClassName(sido_1.code))}>{sido_1.labelText}</text></g>;
  });
  let t12;
  if ($[9] !== t10 || $[10] !== t11 || $[11] !== t6 || $[12] !== t9) {
    t12 = <svg className={t5} viewBox={t6} role={t7} aria-label={t8}>{t9}{t10}{t11}</svg>;
    $[9] = t10;
    $[10] = t11;
    $[11] = t6;
    $[12] = t9;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  return t12;
};
function _temp(t0) {
  const {
    isExternal
  } = t0;
  return isExternal;
}